// src/pages/AdminDashboard.js
import React from 'react';
import { useAuth } from '../context/AuthContext';

const AdminDashboard = () => {
  const { currentUser } = useAuth();

  return (
    <div>
      <h1>Painel do Administrador</h1>
      <p>Bem-vindo, <strong>{currentUser?.displayName}</strong>!</p>
      <p>Esta é a sua área de gerenciamento. Use o menu à esquerda para navegar pelas seções.</p>
    </div>
  );
};

export default AdminDashboard;